import { FC } from 'react';
import { Flex, FlexProps, Stack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';

interface ListTitleProps extends FlexProps {
  title: string;
  count?: number;
}

const ListTitle: FC<ListTitleProps> = ({
  children,
  count,
  title,
  ...props
}) => (
  <Flex paddingBottom="space-24" {...props}>
    <Stack direction="row" spacing="space-8">
      <Heading size="sm">{title}</Heading>

      {count ? (
        <Heading color="text-discreet" size="sm">
          ({count})
        </Heading>
      ) : null}
    </Stack>

    {children}
  </Flex>
);

export default ListTitle;
